import { render, staticRenderFns } from "./ApplyForWish.vue?vue&type=template&id=0fb8b298&scoped=true&"
import script from "./ApplyForWish.vue?vue&type=script&lang=js&"
export * from "./ApplyForWish.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForWish.vue?vue&type=style&index=0&id=0fb8b298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8b298",
  null
  
)

export default component.exports